import { Space } from '../model/space';
export class SpaceBuilder {
    static buildSpace(data) {
        let space = null;
        space = new Space();
        space.number = data.number;
        space.type = data.type;
        space.id_reservation = data.id_reservation;
        space.enabled = data.enabled;
        return space;
    }
}
//# sourceMappingURL=space-builder.js.map